import { render, staticRenderFns } from "./TableListImmo.vue?vue&type=template&id=54476ec8&"
import script from "./TableListImmo.vue?vue&type=script&lang=js&"
export * from "./TableListImmo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports